import { SVGProps } from 'react';

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.42091 10.1126C5.42091 7.5259 7.5259 5.42091 10.1126 5.42091C12.6992 5.42091 14.8042 7.5259 14.8042 10.1126C14.8042 12.6992 12.6992 14.8042 10.1126 14.8042C7.5259 14.8042 5.42091 12.6992 5.42091 10.1126ZM21.707 19.4956L16.6291 14.4177C17.4485 13.1823 17.9318 11.7044 17.9318 10.1124C17.9318 5.80075 14.424 2.29297 10.1124 2.29297C5.80075 2.29297 2.29297 5.80075 2.29297 10.1124C2.29297 14.424 5.80075 17.9318 10.1124 17.9318C11.7044 17.9318 13.1823 17.4485 14.4177 16.6291L19.4956 21.707L21.707 19.4956Z"
      fill="currentColor"
    />
  </svg>
);
